import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import r from "../managers/braze-instance.js";
import c from "../common/event-logger.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
import { validateCustomProperties as nt, validateCustomString as mt } from "../util/validation-utils.js";
import { LOG_CUSTOM_EVENT_STRING as gt } from "../common/constants.js";
export function logCustomEvent(t, e) {
  if (!r.rr()) return !1;
  if (null == t || t.length <= 0) return E.error("logCustomEvent requires a non-empty eventName, got \"".concat(t, "\". Ignoring event.")), !1;
  if (!mt(t, "log custom event", "the event name")) return !1;
  var _nt = nt(e, gt, "eventProperties", "log custom event \"".concat(t, "\""), "event"),
    _nt2 = _slicedToArray(_nt, 2),
    o = _nt2[0],
    n = _nt2[1];
  if (!o) return !1;
  var i = r.l();
  if (i && i.ge(t)) return E.info("Custom Event \"".concat(t, "\" is blocklisted, ignoring.")), !1;
  var s = c.rt(m.CustomEvent, {
    n: t,
    p: n
  });
  if (s.W) {
    E.info("Logged custom event \"".concat(t, "\"."));
    var _iterator = _createForOfIteratorHelper(s.ue),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o = _step.value;
        rt.o().ve(ot.pe, [t, e], _o);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return s.W;
}